<template>
  <v-card :loading="loading">
    <v-form>
      <v-container>
        <fieldset>
          <legend>Call Details</legend>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Full Name</label>
              <v-text-field
                v-model="data.full_name"
                :error-messages="errors.full_name"
                label="Full Name"
                placeholder="Full Name"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Contact Number</label>
              <v-text-field
                label="Contact Number"
                v-model="data.contact_number"
                :error-messages="errors.contact_number"
                placeholder="Contact Number"
                type="number"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Email</label>
              <v-text-field
                label="Email"
                v-model="data.email"
                :error-messages="errors.email"
                type="email"
                placeholder="Email"
                solo
              ></v-text-field>
            </v-col>
          </v-row>
        </fieldset>

        <v-row>
          <v-col cols="12">
            <v-btn :loading="loading" @click="save" color="primary">Save</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import Form from "../../utils/form/Form";
import { DAYSSELECTOR } from "../../utils/constants";
import { Countries } from "../../utils/constants";

export default {
  name: "AddTutorCallData",
  props: {
    id: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      errors: {},
      data: {
        full_name: "",
        email: "",
        contact_number: "",
      },

      loading: true,
    };
  },
  methods: {
    save() {
      if (this.$route.params.id) {
        this.update();
      } else {
        this.create();
      }
    },
    create() {
      let form = new Form({
        ...this.data,
      });
      form
        .post(apiRoutes.AddCallData.url)
        .then((response) => {
          this.$router.replace({
            name: "RecordManagement",
          });
        })
        .catch((response) => {
          console.log(response);
          if (response.status === 400) {
            this.errors = response.data;
          }
          if (response.status === 422) {
            this.errors = response.data.errors;
          }
        });
    },
    update() {
      // alert('ss')
      let form = new Form({
        ...this.data,
      });
      form
        .patch(apiRoutes.AddCallData.url + "/" + this.$route.params.id)
        .then((response) => {
            this.$router.replace({
            name: "RecordManagement",
          });
        })
        .catch((response) => {
          console.log(response);
          if (response.status === 422) {
            this.errors = response.data.errors;
          }
        });
    },
  },
  mounted() {
    this.loading = false;
    if (this.$route.params.id) {
      this.loading = true;

      axios
        .get(apiRoutes.AddCallData.url + "/" + this.$route.params.id)
        .then((response) => {
          this.loading = false;
          console.log(response.data);
          this.data.full_name = response.data.response.fname;
          this.data.email = response.data.response.email;

          this.data.contact_number = response.data.response.contact_no;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }
}
</style>
